var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_251",
    "data-name": "Group 251",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M7.586,9.335A4.425,4.425,0,0,1,3.465,4.667,4.426,4.426,0,0,1,7.586,0,4.425,4.425,0,0,1,11.7,4.667,4.424,4.424,0,0,1,7.586,9.335m0-8.263a3.36,3.36,0,0,0-3.049,3.6,3.36,3.36,0,0,0,3.049,3.6,3.359,3.359,0,0,0,3.047-3.6,3.359,3.359,0,0,0-3.047-3.6",
    transform: "translate(0.249)",
    fill: "#40d857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M14.646,20.319H.845a.538.538,0,0,1-.535-.5l-.3-4.453A4.035,4.035,0,0,1,2.52,11.65a15.556,15.556,0,0,1,10.447,0,4.023,4.023,0,0,1,2.518,3.72l-.306,4.451a.535.535,0,0,1-.534.5m-13.3-1.072h12.8l.269-3.952A2.949,2.949,0,0,0,12.6,12.656a14.505,14.505,0,0,0-9.716,0A2.971,2.971,0,0,0,1.075,15.3Z",
    transform: "translate(0 0.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M14.646,20.319H.845a.538.538,0,0,1-.535-.5l-.3-4.453A4.035,4.035,0,0,1,2.52,11.65a15.556,15.556,0,0,1,10.447,0,4.023,4.023,0,0,1,2.518,3.72l-.306,4.451a.535.535,0,0,1-.534.5m-13.3-1.072h12.8l.269-3.952A2.949,2.949,0,0,0,12.6,12.656a14.505,14.505,0,0,0-9.716,0A2.971,2.971,0,0,0,1.075,15.3Z",
    transform: "translate(0 0.773)",
    fill: "#40d857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M21.872,20.241h-5.5a.536.536,0,0,1,0-1.072h5l.229-3.346a2.511,2.511,0,0,0-1.52-2.205,12.309,12.309,0,0,0-3.934-.715.536.536,0,0,1-.526-.546.548.548,0,0,1,.546-.526,13.365,13.365,0,0,1,4.28.779A3.557,3.557,0,0,1,22.67,15.9l-.264,3.845a.536.536,0,0,1-.535.5",
    transform: "translate(0.123 0.851)",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M17.731,10.267A3.567,3.567,0,0,1,14.4,6.511a3.567,3.567,0,0,1,3.332-3.757,3.565,3.565,0,0,1,3.327,3.757,3.565,3.565,0,0,1-3.327,3.756m0-6.441a2.5,2.5,0,0,0-2.26,2.685A2.5,2.5,0,0,0,17.731,9.2a2.5,2.5,0,0,0,2.255-2.684,2.5,2.5,0,0,0-2.255-2.685",
    transform: "translate(0.036 0.198)",
    fill: "#0d292d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUsers);
export default __webpack_public_path__ + "static/media/newUsers.548925290add557c1e89b4f020c4d034.svg";
export { ForwardRef as ReactComponent };